import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';
import {TooltipEl} from 'common/components/tooltip';
import {Placement} from 'common/components/tooltip/types';

export const FieldLabel = (fieldName, tooltipText = null) => {
  return (
    <div sel='.pre-selected-events'>
      <div sel='.pre-selected-events-text'>{fieldName}</div>
      {tooltipText && (
        <div sel='.info-icon-wrapper'>
          <SvgIconEl sel='.info-icon' attrs={{icon: `info`}} />
          <TooltipEl
            sel='.info-icon-tooltip'
            attrs={{'max-width': `260px`, placement: Placement.RightCenter, text: tooltipText}}
          />
        </div>
      )}
    </div>
  );
};
